export const filterSystemAndCurrentUser = function (users, currentProfile) {
  if (!users || !currentProfile) return [];

  return users.filter(user => !user.isSystemUser && user.id !== currentProfile.id);
};
